import { dataServiceBaseUrl } from "@/data-access/core/constants";

/**
 * Browser URL for a stored Image.src. Relative `/media` paths load from the API origin.
 */
export const resolveLayoutAssetPreviewUrl = (src: string): string => {
  const trimmed = src.trim();
  if (trimmed === "") return "";
  if (/^(https?:|blob:|data:)/i.test(trimmed)) return trimmed;
  if (!trimmed.startsWith("/")) return trimmed;

  const apiOrigin = dataServiceBaseUrl.replace(/\/$/, "");
  return `${apiOrigin}${trimmed}`;
};
